export default "__VITE_ASSET__77iCexdO__$_?url__"